import React from 'react'
import WarningOrangeSvg from '../../../assets/icons/WarningOrangeSvg'
import WarningYellowSvg from '../../../assets/icons/WarningYellowSvg'
import LocationTargetWhiteSvg from '../../../assets/icons/LocationTargetWhiteSvg'
import RedoWhiteSvg from '../../../assets/icons/RedoWhiteSvg'
import SuccessGreenSvg from '../../../assets/icons/SuccessGreenSvg'
import ModalButton from './ModalButton'

const ModalBody = ({ toggle, error, onRetryVerification, successMessage }) => {
  const isSuccessState = (text) => text === ''

  // Cihazın konum ayarlarına yönlendiren fonksiyon
  const openLocationSettings = () => {
    const userAgent = navigator.userAgent.toLowerCase()

    // Mobil cihazlarda da modal rehber göster
    if (userAgent.includes('android') || userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ios')) {
      // Mobil cihazlar için modal kapanacak, kullanıcı açıklamayı okudu
      toggle()
    } else {
      // Web browser için detaylı rehber
      showLocationGuide()
    }
  }

  // Tarayıcı konum ayarları rehberi
  const showLocationGuide = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    let guide = ''

    if (userAgent.includes('chrome')) {
      guide = 'Chrome\'da:\n1. Adres çubuğunun solundaki kilit ikonuna tıklayın\n2. "Konum" ayarını "İzin ver" olarak değiştirin\n3. Sayfayı yenileyin'
    } else if (userAgent.includes('firefox')) {
      guide = 'Firefox\'ta:\n1. Adres çubuğunun solundaki kalkan ikonuna tıklayın\n2. Konum iznini etkinleştirin\n3. Sayfayı yenileyin'
    } else if (userAgent.includes('safari')) {
      guide = 'Safari\'de:\n1. Safari > Tercihler > Web Siteleri > Konum\n2. Bu siteyi "İzin ver" listesine ekleyin'
    } else {
      guide = 'Tarayıcınızda:\n1. Adres çubuğundaki site ayarları ikonuna tıklayın\n2. Konum iznini etkinleştirin\n3. Sayfayı yenileyin'
    }
    
    alert(guide)
    toggle()
  }

  // Kullanıcının cihazına göre izin yönlendirmesini sadeleştirir.
  const getUserDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.includes('android')) return 'android'
    if (userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ios')) return 'ios'
    return 'web'
  }

  // error olayı farklı metinler ve ya hata kodu olarak gelebilir, test aşamasında tekrar düzenlenmeli
  const icon = (text) => {
    switch (text) {
      case 'Konum':
        return <WarningOrangeSvg width={'4rem'} />
      case 'Mesafe':
        return <WarningYellowSvg width={'4rem'} />
      case 'Bluetooth':
        return <WarningYellowSvg width={'4rem'} />
      case 'İzin':
        return <WarningOrangeSvg width={'4rem'} />
      case 'Süre':
        return <WarningOrangeSvg width={'4rem'} />

      default:
        return isSuccessState(text) ? <SuccessGreenSvg width={'4rem'} /> : <WarningYellowSvg width={'4rem'} />
    }
  }

  const title = (text) => {
    switch (text) {
      case 'Konum':
        return 'Konum İzni Gerekli'
      case 'Mesafe':
        return 'Dikkat'
      case 'Bluetooth':
        return 'Bluetooth Doğrulanamadı'
      case 'İzin':
        return 'İzin Gerekli'
      case 'Süre':
        return 'Mükerrer Deneme'

      default:
        return isSuccessState(text) ? 'İşlem Başarılı' : 'Bariyer açılamadı'
    }
  }

  const desc = (text) => {
    const device = getUserDevice()

    switch (text) {
      case 'Konum':
        if (device === 'android') {
          return 'Telefon Ayarları > Uygulamalar > KARATAY > İzinler > Konum ayarından "İzin ver" seçeneğini aktifleştirin.'
        } else if (device === 'ios') {
          return 'Ayarlar > Gizlilik ve Güvenlik > Konum Servisleri > KARATAY > "Uygulama Kullanılırken" seçeneğini işaretleyin.'
        } else {
          return 'Bu işlemi gerçekleştirebilmek için konum izni vermeniz\ngerekmektedir.'
        }
      case 'Mesafe':
        return 'Bariyere yakın konumda olmadığınız için\nbu işlemi gerçekleştiremezsiniz.'
      case 'Bluetooth':
        return 'Raspberry Bluetooth yayını doğrulanamadığı için\nişlem tamamlanamadı.'
      case 'İzin':
        return 'Bariyeri açmak için Bluetooth ve Konum izinleri zorunludur.\nLütfen iki izni de verip tekrar deneyin.'
      case 'Süre':
        return 'Bariyeri 5 dakika içerisinde yalnızca\n1 kez açabilirsiniz.'

      default:
        return isSuccessState(text) ? successMessage || 'Bariyer açılıyor, giriş yapabilirsiniz.' : text || 'Bilinmeyen hata oluştu.'
    }
  }

  const btn = (text) => {
    const device = getUserDevice()

    switch (text) {
      case 'Konum':
        return (
          <ModalButton
            backgroundColor={'#E66725'}
            text={device === 'web' ? 'Konum Ayarları' : 'İzin Ver - Tekrar Dene'}
            icon={<LocationTargetWhiteSvg width={'1.5rem'} />}
            onClick={openLocationSettings}
          />
        )
      case 'Mesafe':
        return (
          <ModalButton
            backgroundColor={'#EFB01C'}
            text={'Tekrar Dene'}
            icon={<RedoWhiteSvg width={'1.5rem'} />}
            onClick={() => {
              toggle()
            }}
          />
        )
      case 'Bluetooth':
        return (
          <ModalButton
            backgroundColor={'#EFB01C'}
            text={'Tekrar Dene'}
            icon={<RedoWhiteSvg width={'1.5rem'} />}
            onClick={() => {
              toggle()
              if (typeof onRetryVerification === 'function') {
                onRetryVerification()
              }
            }}
          />
        )
      case 'İzin':
        return (
          <ModalButton
            backgroundColor={'#E66725'}
            text={'İzinleri Aç'}
            icon={<LocationTargetWhiteSvg width={'1.5rem'} />}
            onClick={() => {
              toggle()
              if (typeof onRetryVerification === 'function') {
                onRetryVerification()
              }
            }}
          />
        )
      case 'Süre':
        return (
          <ModalButton
            backgroundColor={'#E66725'}
            text={'Tekrar Dene'}
            icon={<RedoWhiteSvg width={'1.5rem'} />}
            onClick={() => {
              toggle()
            }}
          />
        )

      default:
        return isSuccessState(text) ? null : (
          <ModalButton
            backgroundColor={'#EFB01C'}
            text={'Tekrar Dene'}
            icon={<RedoWhiteSvg width={'1.5rem'} />}
            onClick={() => {
              toggle()
              if (typeof onRetryVerification === 'function') {
                onRetryVerification()
              }
            }}
          />
        )
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: '.8rem',
        padding: error === '' ? '1.5rem 0 0 0' : '.6rem 0 0 0',
      }}
    >
      {icon(error)}
      <div
        style={{
          fontSize: '20px',
          fontWeight: '700',
          color: error === '' ? '#205c42' : '#000',
        }}
      >
        {title(error)}
      </div>
      <div
        style={{
          lineHeight: error === '' ? 1 : 1.4,
          margin: error === '' ? '-.5rem' : 'auto',
          color: error === '' ? '#205c42' : '#000',
          fontWeight: '300',
          padding: '0 1rem',
        }}
      >
        {desc(error)
          .split('\n')
          .map((str) => (
            <p key={str} style={{ margin: '0.2rem 0' }}>{str}</p>
          ))}
      </div>
      <div style={{ width: '100%' }}>{btn(error)}</div>
    </div>
  )
}

export default ModalBody
